export const loginFormModalTextContent = {
  ModalTitleText: "Open More Page",
  btnText: "Submit"
}
